import React, { useState, useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import './matchcss.css';
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import useSubjectName from './useSubjectName';
import { API_BASE_URL } from '../../../../../Helpers/apiConfig';

const VideoContent = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const [url, setUrl] = useState([]);
    const { user } = useAuth();
    const subjectName = useSubjectName();
    const [msg, setMsg] = useState([]);
    const [isVideoEnded, setIsVideoEnded] = useState(false);
    // Çift tıklamada aynı cevabın backend'e iki kez gönderilmesini engeller (Y7).
    const sendingRef = useRef(false);
    const Request = async (e) => {
        e.preventDefault();
        if (sendingRef.current) return;
        sendingRef.current = true;

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = `${API_BASE_URL}/user/Content/Answer`;
            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: "video"
                },
                headers: headerss
            }).then(res => {
                nextquestion();
            });

        } catch (err) {
            sendingRef.current = false;
            setMsg(err.message);
        }
    };

    function nextquestion() {
        const n = Number(params.id);
        const newId = n + 1;

        if (newId > props.questionCount) {
            navigate("/user/course/subject");
        } else {
            window.location.href =
                "/user/course/question/" + params['courseid'] + "/" +
                params.subjectid + "/" +
                newId;
        }
    }

    useEffect(() => {
        setUrl(props.data.contentStr);
    }, []);

    return (
        <div className="video-page">
            <style>
                {`
                .video-page {
                    width: 100%;
                    box-sizing: border-box;
                    padding-bottom: 32px;
                }

                .video-subject {
                    color: black;
                }

                .video-player-container {
                    display: flex;
                    justify-content: center;
                    width: 100%;
                }

                .video-wrapper {
                    position: relative;
                    width: 80%;
                    max-width: 1100px;
                    border-radius: 12px;
                    overflow: hidden;
                    padding-top: 45%;
                    background: #000;
                }

                .video-wrapper .react-player {
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                .video-actions {
                    display: flex;
                    justify-content: center;
                    margin-top: 18px;
                }

                .continue-btn {
                    min-width: 260px;
                }

                @media (min-width: 769px) and (max-width: 1024px) {
                    .video-wrapper {
                        width: 90%;
                        padding-top: 50%;
                    }

                    .continue-btn {
                        width: 70%;
                        min-width: unset;
                        font-size: 18px;
                        padding: 14px;
                    }

                    .video-page {
                        padding-bottom: 80px;
                    }
                }

                @media (max-width: 768px) {
                    .video-page {
                        padding-bottom: 90px;
                    }

                    .video-wrapper {
                        width: 100%;
                        padding-top: 56.25%;
                        border-radius: 10px;
                    }

                    .video-actions {
                        padding: 0 8px;
                    }

                    .continue-btn {
                        width: 100%;
                        max-width: 360px;
                        min-width: unset;
                        font-size: 18px;
                        padding: 14px;
                    }
                }

                @media (max-width: 480px) {
                    .video-page {
                        padding-bottom: 100px;
                    }

                    .continue-btn {
                        font-size: 16px;
                        padding: 12px;
                    }
                }
                `}
            </style>

            <span className="video-subject">
                <b><i>{subjectName}</i></b>
            </span>

            <br /><br />

            <div className="video-player-container">
                <div className="video-wrapper">
                    <ReactPlayer
                        className="react-player"
                        url={url}
                        width="100%"
                        height="100%"
                        controls
                        onEnded={() => setIsVideoEnded(true)}
                        config={{
                            file: {
                                attributes: {
                                    controlsList: "nodownload",
                                    disablePictureInPicture: true
                                }
                            }
                        }}
                    />
                </div>
            </div>

            <div className="video-actions">
                <button
                    type="button"
                    className="save-btn continue-btn"
                    onClick={Request}
                    disabled={!isVideoEnded}
                >
                    {isVideoEnded ? "Next" : "Lütfen Önce Videoyu Bitirin"}
                </button>
            </div>
        </div>
    );
};

export default VideoContent;